enum UploadStatus {
    authorising = 'Authorising',
    pending = 'Pending',
    uploading = 'Uploading',
    uploaded = 'Uploaded',
    cancelled = 'Cancelled',
    failed = 'Failed',
    failedAuthorisation = 'FailedAuthorisation'
}

export default UploadStatus;
